import OrderAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource";
import {cloneDeep} from "lodash";
import DisclosureAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/DisclosureAppResource";
import dayjs from "dayjs";
import axios from "axios";
export default {
    data: () => ({
        orderAppResource: null,
        confirmationNode: null,
        confirmationNodeShown: false
        // orderUuid: null - Commented since affecting props in the file OrderDisclosureForm.vue and also I dont see using this anywhere else
    }),
    computed: {
        confirmationModal(){
            return this.confirmationNode;
        },
        confirmationModalShow(){
            return this.confirmationNodeShown;
        }
    },
    methods: {
        async updateOrderForms(state_id, orderFormTypeSelection, order_uuid){
            try {
                await axios.post(`${window.env.MILESTONES_API_HOST}/api/v1/orders/update-form`, {
                    state_id: state_id,
                    orderForms: orderFormTypeSelection,
                    order_uuid: order_uuid
                });
            } catch (error) {
                const response = error?.response || {};
                console.log(response)
            }
        },
        async fetchOrder() {
            let orderAppResource = new OrderAppResource({uuid: this.$route.params.uuid});

            await orderAppResource.find([
                'agent',
                'broker',
                'disclosure',
                'disclosure.jotFormDisclosureSessions',
                'disclosure.jotFormDisclosureSessions.files',
                'disclosure.jotFormDisclosureSessions.form',
                'disclosure.jotFormDisclosureSessions.form.parentForm',
                'disclosure.jotFormDisclosureSessions.form.sections',
                'forms',
                'forms.parentForm',
                'forms.sections',
                'homeSaleLegalProtection',
                'invitation',
                'property',
                'property.state',
                
            ]);
            this.orderAppResource = cloneDeep(orderAppResource);
        },
        async completeOnboarding(){
            if (this.orderAppResource?.uuid) {
                let disclosureAppResource = this.orderAppResource?.disclosure ? cloneDeep(this.orderAppResource.disclosure) : new DisclosureAppResource({});

                if (!disclosureAppResource?.orderUuid) {
                    disclosureAppResource.setAttribute('orderUuid', this.orderAppResource?.uuid);
                }

                disclosureAppResource.setAttribute('onboardingComplete', true);
                await disclosureAppResource.save();

                this.orderAppResource.setAttribute('eulaAcceptedAt', dayjs(Date.now()));
                await this.orderAppResource.save();
            }   
        },
        async LeaveFormModal(){
            if(this.confirmationModalShow){
                return Promise.resolve(false);
            }
            this.confirmationNodeShown = true;
            const value = await this.$bvModal.msgBoxConfirm(this.confirmationModal,{
                centered: true,
                footerClass: 'confirmation-modal-footer',
                okTitle: 'Leave Form',
                size:'sm',
                noCloseOnBackdrop: true,
                noCloseOnEsc: true,
                id: 'leave-form-modal',
                ref: 'leav-form-modal'
            });
            this.confirmationNodeShown = false;
            return Promise.resolve(value);
        }
    },
    beforeMount(){
        if(!this.confirmationNode){
            const h = this.$createElement;
            const messageVNode = h('b-container', {class: 'confirmation-modal-body'},[
                h('b-row', {},[
                    h('b-col',{},[
                        h('b-img', {
                            props:{
                                src: require('@assets/images/v3/Warning.svg'),
                                center: true
                            }
                        })
                    ])
                ]),
                h('b-row', {},[
                    h('b-col', {},[
                        h('h5',{}, ['Leaving Form'])
                    ])
                ]),
                h('b-row',{},[
                    h('b-col', {}, [
                        h('p', {}, ['Work will not be saved if you leave before the form is saved or submitted. The lost information cannot be recovered.'])
                    ])
                ])
            ]);
            this.confirmationNode = messageVNode;
        }
    },
    unmounted(){
        this.confirmationNodeShown = false;
    }
};
